import React, { useState, useMemo } from 'react';
import { CreateFlowModal } from './CreateFlowModal';
import { ModalContent, FormPrimaryButton } from './shared/FormComponents';
import { CreateFlowBackButton } from './shared/CreateFlowBackButton';
import { CreateFlowStepIndicator } from './shared/CreateFlowStepIndicator';
import styled from 'styled-components';
import { Color } from 'core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AddContentToCourse } from '../shared/AddContentToCourse';
import { ISet } from 'models/set';

interface IProps {
  onClose: () => void;
  onBack: () => void;
  onDone: () => void;
  contentItem: ISet;
}

export const AttachToCourseModal = (props: IProps) => {
  const { onClose, onBack, onDone, contentItem } = props;

  return (
    <CreateFlowModal title="Attach to Course" onClose={onClose}>
      <ModalContent style={{ paddingBottom: 0 }}>
        <div style={{ visibility: 'hidden' }}>
          {/* 
              Hidden so it takes up the appropriate space, but we don't want 
              them to be able to go back because the content will have already been created 
              at this point in the flow
          */}
          <CreateFlowBackButton onClick={() => {}} />
        </div>

        <CreateFlowStepIndicator activeStep={3} />

        <MainTitle>Choose courses to add this content, or skip to keep it standalone.</MainTitle>
        <AddContentToCourse contentItem={contentItem} />

        <BottomToolbar>
          <FormPrimaryButton onClick={onDone}>Done</FormPrimaryButton>
        </BottomToolbar>
      </ModalContent>
    </CreateFlowModal>
  );
};

const MainTitle = styled.h2`
  text-align: center;
  font-size: 20px;
  color: ${Color.primaryBlack};
  margin: 0 0 32px 0;
  font-weight: 500;
`;

const BottomToolbar = styled.div`
  position: sticky;
  background: white;
  border-top: 1px solid ${Color.lightGray};
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;

  // To offset padding of BaseModal
  bottom: -24px;
  margin-top: 32px;
  margin-bottom: -24px;
`;
